import { addMinutes, isSameDay } from 'date-fns';
import { formatDate } from './formatDate';
import { formatTime } from './formatTime';
export const formatTimeRange = (startDate, durationMinutes) => {
    const endDate = addMinutes(startDate, durationMinutes);
    if (isSameDay(startDate, endDate)) {
        return `${formatTime(startDate)} - ${formatTime(endDate)}`;
    }
    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
};
